import React from 'react';

export default function NatalChartStyles() {
  return (
    <style>{`
      :root {
        --natal-bg: #070617;
        --natal-bg-soft: #100723;
        --natal-panel: rgba(26, 8, 52, 0.92);
        --natal-panel-soft: rgba(38, 10, 72, 0.78);
        --natal-panel-deep: rgba(12, 4, 30, 0.94);
        --natal-purple: #7132b7;
        --natal-purple-soft: #a86be3;
        --natal-gold: #f1c85a;
        --natal-gold-soft: #ffe39a;
        --natal-text: #fff9eb;
        --natal-muted: #c5b2d8;
        --natal-border: rgba(150, 74, 216, 0.48);
        --natal-gold-border: rgba(241, 200, 90, 0.42);
      }

      #natalRoot {
        position: relative;
        min-height: 100svh;
        overflow-x: hidden;
        color: var(--natal-text);
        background:
          radial-gradient(circle at 18% 16%, rgba(120, 50, 190, 0.26), transparent 28%),
          radial-gradient(circle at 82% 32%, rgba(85, 32, 155, 0.22), transparent 32%),
          radial-gradient(circle at 52% 84%, rgba(74, 20, 130, 0.30), transparent 40%),
          radial-gradient(circle at 20% 35%, rgba(255,255,255,0.70) 0 0.7px, transparent 1px),
          radial-gradient(circle at 76% 16%, rgba(255,255,255,0.60) 0 0.6px, transparent 1px),
          radial-gradient(circle at 64% 70%, rgba(255,255,255,0.45) 0 0.7px, transparent 1px),
          linear-gradient(180deg, #060514 0%, #090619 45%, #120626 100%);
        background-size:
          auto,
          auto,
          auto,
          58px 58px,
          74px 74px,
          96px 96px,
          auto;
      }

      #natalRoot::before {
        content: '';
        position: fixed;
        inset: 0;
        pointer-events: none;
        background:
          linear-gradient(
            180deg,
            rgba(4, 3, 15, 0.18),
            rgba(4, 3, 15, 0.42)
          );
        z-index: 0;
      }

      .natal-fixed-bg {
        position: fixed;
        inset: 0;
        overflow: hidden;
        pointer-events: none;
        z-index: 0;
      }

      .natal-fixed-bgWheel {
        position: absolute;
        width: min(108vw, 720px);
        height: min(108vw, 720px);
        left: 50%;
        top: 31%;
        transform: translate(-50%, -50%);
        opacity: 0.17;
        filter: blur(7px) saturate(1.25);
        animation: natalSlowSpin 90s linear infinite;
      }

      .natal-fixed-bgWheel::before {
        content: '';
        position: absolute;
        inset: 10%;
        border-radius: 50%;
        background:
          radial-gradient(circle, rgba(158, 70, 220, 0.32), rgba(79, 23, 140, 0.12) 48%, transparent 72%);
        box-shadow:
          0 0 100px rgba(133, 46, 210, 0.40),
          0 0 170px rgba(91, 27, 165, 0.26);
      }

      .natal-fixed-bgWheel img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 50%;
        opacity: 0.72;
      }

      @keyframes natalSlowSpin {
        from {
          transform: translate(-50%, -50%) rotate(0deg);
        }
        to {
          transform: translate(-50%, -50%) rotate(360deg);
        }
      }

      .natal-premium-header {
        display: grid;
        grid-template-columns: 44px 1fr 44px;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
      }

      .natal-header-icon {
        position: relative;
        z-index: 2;
        width: 40px;
        height: 40px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        border: 1px solid rgba(154, 88, 218, 0.42);
        background: rgba(26, 9, 54, 0.74);
        color: #fff;
        font-size: 27px;
        line-height: 1;
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.05);
      }

      .natal-header-menu {
        font-size: 24px;
      }

      .natal-header-copy {
        position: relative;
        z-index: 2;
        min-width: 0;
        text-align: center;
      }

      .natal-header-copy h1 {
        margin: 0;
        color: var(--natal-gold-soft);
        font-size: clamp(22px, 6vw, 29px);
        font-family: Georgia, 'Times New Roman', serif;
        font-weight: 500;
        letter-spacing: 0.2px;
      }

      .natal-header-copy p {
        margin: 4px 0 0;
        color: var(--natal-muted);
        font-size: 12px;
      }

      .natal-success-pill {
        width: fit-content;
        max-width: 100%;
        margin: 0 auto 14px;
        padding: 7px 14px;
        border-radius: 999px;
        border: 1px solid rgba(84, 214, 125, 0.28);
        background: rgba(26, 70, 48, 0.34);
        color: #d9ffe5;
        font-size: 12px;
        text-align: center;
        box-shadow: 0 6px 18px rgba(0,0,0,0.18);
      }

      .natal-birth-toggle {
        width: 100%;
        display: grid;
        grid-template-columns: 36px 1fr 24px;
        align-items: center;
        gap: 10px;
        margin: 12px 0;
        padding: 13px 14px;
        border-radius: 16px;
        border: 1px solid var(--natal-border);
        background:
          linear-gradient(
            135deg,
            rgba(47, 13, 84, 0.93),
            rgba(24, 7, 52, 0.94)
          );
        color: var(--natal-text);
        text-align: left;
        box-shadow:
          0 12px 28px rgba(0,0,0,0.26),
          inset 0 1px 0 rgba(255,255,255,0.04);
        cursor: pointer;
      }

      .natal-birth-toggle-icon {
        font-size: 19px;
      }

      .natal-birth-toggle-copy {
        display: flex;
        flex-direction: column;
        gap: 3px;
        min-width: 0;
      }

      .natal-birth-toggle-copy strong {
        color: var(--natal-gold-soft);
        font-size: 13px;
      }

      .natal-birth-toggle-copy small {
        color: var(--natal-muted);
        font-size: 11px;
      }

      .natal-birth-toggle-chevron {
        color: #d6c3ec;
        font-size: 18px;
        text-align: center;
        transition: transform 180ms ease;
      }

      .natal-birth-toggle-chevron.is-open {
        transform: rotate(180deg);
      }

      .natal-form-actions {
        position: relative;
        z-index: 5;
        margin-top: 14px;
      }

      .natal-primary-action,
      .natal-back-button {
        width: 100%;
        border-radius: 17px;
        border: 1px solid var(--natal-gold-border);
        background:
          linear-gradient(
            135deg,
            rgba(55, 17, 94, 0.94),
            rgba(25, 8, 55, 0.96)
          );
        color: var(--natal-gold-soft);
        padding: 12px 16px;
        font-size: 13px;
        font-weight: 800;
        cursor: pointer;
        box-shadow:
          0 10px 24px rgba(0,0,0,0.28),
          inset 0 1px 0 rgba(255,255,255,0.04);
      }

      .natal-primary-action:disabled {
        opacity: 0.65;
        cursor: default;
      }

      .natal-back-button {
        margin-top: 16px;
        border-color: rgba(132, 69, 190, 0.42);
        color: #fff;
        font-weight: 500;
      }

      .natal-result-shell,
      .natal-section-surface,
      .natal-stable-block,
      .dominant-card,
      .pattern-card,
      .aspect-card,
      .integrated-card,
      .it-card {
        color: var(--natal-text);
        border-radius: 16px !important;
        border: 1px solid var(--natal-border) !important;
        background:
          linear-gradient(
            145deg,
            rgba(37, 10, 68, 0.95),
            rgba(15, 5, 35, 0.96)
          ) !important;
        box-shadow:
          0 14px 32px rgba(0,0,0,0.28),
          inset 0 1px 0 rgba(255,255,255,0.04) !important;
      }

      .natal-result-shell {
        overflow: visible !important;
      }

      .natal-result-shell > div:first-child {
        padding: 4px 2px 0;
      }

      .natal-result-shell > div:first-child > div:first-child {
        color: var(--natal-gold-soft) !important;
      }

      .natal-chart-tabs {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 4px;
        margin: 12px 0 8px;
        padding: 3px;
        border-radius: 14px;
        border: 1px solid rgba(137, 65, 204, 0.34);
        background: rgba(20, 5, 43, 0.88);
      }

      .natal-chart-tab {
        min-height: 38px;
        border: 0;
        border-radius: 11px;
        background: transparent;
        color: #d7c7e8;
        font-size: 12px;
        cursor: pointer;
      }

      .natal-chart-tab.is-active {
        color: #fff;
        background:
          linear-gradient(
            135deg,
            rgba(100, 26, 170, 0.96),
            rgba(60, 11, 116, 0.96)
          );
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.08),
          0 6px 16px rgba(0,0,0,0.20);
      }

      .natal-accordion {
        overflow: hidden;
        border-radius: 15px;
        border: 1px solid rgba(132, 62, 192, 0.42);
        background:
          linear-gradient(
            135deg,
            rgba(42, 11, 75, 0.92),
            rgba(20, 6, 43, 0.94)
          );
        box-shadow:
          0 8px 22px rgba(0,0,0,0.20),
          inset 0 1px 0 rgba(255,255,255,0.03);
      }

      .natal-accordion-trigger {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 28px;
        align-items: center;
        gap: 8px;
        padding: 12px 13px;
        border: 0;
        background: transparent;
        color: inherit;
        text-align: left;
        cursor: pointer;
      }

      .natal-accordion-copy {
        display: flex;
        flex-direction: column;
        gap: 3px;
        min-width: 0;
      }

      .natal-accordion-copy strong {
        color: var(--natal-gold-soft);
        font-size: 12.5px;
        line-height: 1.25;
      }

      .natal-accordion-copy small {
        color: var(--natal-muted);
        font-size: 10.5px;
        line-height: 1.35;
      }

      .natal-accordion-chevron {
        color: #d8c7eb;
        font-size: 24px;
        text-align: center;
        transition: transform 180ms ease;
      }

      .natal-accordion.is-open .natal-accordion-chevron {
        transform: rotate(90deg);
      }

      .natal-accordion-content {
        padding: 0 10px 10px;
        background: rgba(8, 3, 22, 0.34);
      }

      .dominant-kicker,
      .pattern-kicker,
      .integrated-kicker,
      .aspect-kicker,
      .it-label {
        color: var(--natal-gold) !important;
      }

      .dominant-subtitle,
      .integrated-subtitle,
      .it-sub {
        color: var(--natal-muted) !important;
      }

      .aspect-title,
      .integrated-title,
      .it-title {
        color: var(--natal-gold-soft) !important;
      }

      .dominant-paragraph,
      .integrated-paragraph,
      .aspect-body,
      .aspect-intro,
      .it-text {
        color: rgba(255, 249, 235, 0.92) !important;
      }

      .natal-scroll-surface {
        scrollbar-width: thin;
        scrollbar-color: rgba(160, 88, 215, 0.7) transparent;
      }

      #natalRoot input,
      #natalRoot select,
      #natalRoot textarea {
        color: #fff !important;
        background: rgba(12, 4, 31, 0.88) !important;
        border: 1px solid rgba(143, 70, 203, 0.48) !important;
        border-radius: 13px !important;
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.03);
      }

      #natalRoot input::placeholder,
      #natalRoot textarea::placeholder {
        color: rgba(215, 199, 232, 0.58) !important;
      }

      #natalRoot label {
        color: var(--natal-gold-soft);
      }

      #natalRoot option {
        color: #fff;
        background: #17062e;
      }

      @media (max-width: 520px) {
        .natal-result-shell {
          padding: 10px !important;
        }

        .natal-premium-header {
          grid-template-columns: 40px 1fr 40px;
        }

        .natal-header-icon {
          width: 38px;
          height: 38px;
        }

        .natal-header-copy h1 {
          font-size: 23px;
        }
      }

      @media (max-width: 390px) {
        .natal-header-copy h1 {
          font-size: 20px;
        }

        .natal-header-copy p {
          font-size: 10.5px;
        }

        .natal-birth-toggle {
          padding: 11px 12px;
        }

        .natal-accordion-trigger {
          padding: 11px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .natal-fixed-bgWheel {
          animation: none;
        }
      }

      /* Boceto premium: correcciones finales */
      .natal-fixed-bg,
      .natal-fixed-bgWheel {
        display: none !important;
        animation: none !important;
      }

      .natal-status-message {
        margin: 10px 0 4px;
        padding: 8px 12px;
        border-radius: 12px;
        font-size: 12px;
        text-align: center;
      }

      .natal-status-message.is-success {
        color: #dfffe7;
        border: 1px solid rgba(83, 215, 126, 0.26);
        background: rgba(29, 76, 51, 0.30);
      }

      .natal-status-message.is-error {
        color: #ffd4d4;
        border: 1px solid rgba(255, 126, 126, 0.28);
        background: rgba(91, 24, 41, 0.32);
      }

      .natal-premium-header {
        position: relative;
        z-index: 4;
      }

      .natal-header-icon {
        appearance: none;
        -webkit-appearance: none;
        touch-action: manipulation;
      }

      .natal-header-icon:active {
        transform: scale(0.94);
      }

      .natal-result-shell {
        margin-top: 12px !important;
      }

      .natal-scroll-surface {
        overflow: visible !important;
      }

      .natal-chart-tabs {
        position: sticky;
        top: 6px;
        z-index: 7;
      }

      /* Refinamiento visual general */
      #natalRoot {
        padding-bottom:
          calc(28px + env(safe-area-inset-bottom, 0px))
          !important;
      }

      .natal-header-spacer {
        position: relative;
        z-index: 2;
        width: 40px;
        height: 40px;
        display: block;
      }

      .natal-premium-header {
        position: sticky;
        top: calc(8px + env(safe-area-inset-top, 0px));
        z-index: 90;
        margin-bottom: 14px;
        padding: 8px;
        border-radius: 18px;
        border: 1px solid rgba(132, 62, 192, 0.24);
        background: rgba(9, 5, 24, 0.88);
        box-shadow: 0 10px 28px rgba(0, 0, 0, 0.32);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
      }

      .natal-premium-header::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        pointer-events: none;
        background:
          linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.035),
            transparent 48%
          );
      }

      .natal-header-copy h1 {
        text-shadow:
          0 0 18px rgba(234, 198, 93, 0.18);
      }

      .natal-success-pill,
      .natal-status-message {
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
      }

      .natal-birth-toggle,
      .natal-summary-card,
      .natal-wheel-card,
      .natal-data-panel,
      .natal-accordion,
      .dominant-card,
      .pattern-card,
      .aspect-card,
      .integrated-card,
      .it-card {
        transition:
          transform 180ms ease,
          border-color 180ms ease,
          box-shadow 180ms ease,
          background 180ms ease;
      }

      .natal-birth-toggle:hover,
      .natal-accordion-trigger:hover,
      .natal-chart-tab:hover,
      .natal-primary-action:hover,
      .natal-back-button:hover {
        border-color:
          rgba(234, 198, 93, 0.58) !important;
      }

      .natal-birth-toggle:active,
      .natal-primary-action:active,
      .natal-back-button:active {
        transform: scale(0.985);
      }

      .natal-result-shell {
        gap: 14px !important;
      }

      .natal-summary-card {
        position: relative;
        overflow: hidden;
      }

      .natal-summary-card::before {
        content: '';
        position: absolute;
        inset: 0 auto 0 0;
        width: 3px;
        background:
          linear-gradient(
            180deg,
            var(--natal-gold),
            var(--natal-purple)
          );
      }

      .natal-wheel-card {
        background:
          radial-gradient(
            circle at center,
            rgba(111, 47, 174, 0.22),
            transparent 58%
          ),
          linear-gradient(
            145deg,
            rgba(35, 10, 65, 0.98),
            rgba(12, 4, 31, 0.98)
          ) !important;
      }

      .natal-chart-tabs {
        box-shadow:
          0 10px 24px rgba(0, 0, 0, 0.22);
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
      }

      .natal-chart-tab {
        font-weight: 700;
      }

      .natal-accordion.is-open {
        border-color:
          rgba(234, 198, 93, 0.34);
        box-shadow:
          0 12px 30px rgba(0, 0, 0, 0.26),
          inset 0 0 0 1px
            rgba(234, 198, 93, 0.05);
      }

      .natal-accordion-trigger {
        min-height: 58px;
      }

      .natal-accordion-content {
        border-top:
          1px solid rgba(255, 255, 255, 0.06);
        padding-top: 10px;
      }

      .dominant-card,
      .pattern-card,
      .aspect-card,
      .integrated-card,
      .it-card {
        padding: 14px !important;
      }

      .it-row {
        padding: 10px 0;
        border-bottom:
          1px solid rgba(255, 255, 255, 0.06);
      }

      .it-row:last-child {
        border-bottom: 0;
      }

      .natal-back-button:focus-visible,
      .natal-header-icon:focus-visible,
      .natal-birth-toggle:focus-visible,
      .natal-chart-tab:focus-visible,
      .natal-accordion-trigger:focus-visible,
      .natal-primary-action:focus-visible {
        outline:
          2px solid var(--natal-gold);
        outline-offset: 2px;
      }

      @media (max-width: 390px) {
        .natal-header-spacer {
          width: 36px;
          height: 36px;
        }

      }


      /* Botón volver flotante y título centrado */
      .natal-premium-header {
        display: grid !important;
        grid-template-columns:
          42px minmax(0, 1fr) 42px !important;
        align-items: center !important;
        position: relative !important;
        top: auto !important;
        z-index: 20 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
      }

      .natal-premium-header::before {
        display: none !important;
      }

      .natal-header-copy {
        grid-column: 2;
        text-align: center !important;
        justify-self: stretch;
        position: relative;
        z-index: 2;
      }

      .natal-header-spacer {
        width: 42px;
        height: 42px;
        display: block;
      }

      .natal-floating-top-back {
        position: fixed;
        top:
          calc(
            14px
            + env(safe-area-inset-top, 0px)
          );
        left:
          max(
            16px,
            calc(50vw - 244px)
          );
        z-index: 160;
        width: 42px;
        height: 42px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        border:
          1px solid
          rgba(145, 76, 207, 0.62);
        background:
          linear-gradient(
            145deg,
            rgba(52, 16, 91, 0.98),
            rgba(17, 6, 39, 0.99)
          );
        color: #fff;
        font-size: 27px;
        line-height: 1;
        cursor: pointer;
        touch-action: manipulation;
        box-shadow:
          0 12px 30px rgba(0, 0, 0, 0.46),
          inset 0 1px 0
            rgba(255, 255, 255, 0.07);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        transition:
          transform 160ms ease,
          border-color 160ms ease,
          box-shadow 160ms ease;
      }

      .natal-floating-top-back:hover {
        border-color:
          rgba(234, 198, 93, 0.72);
        box-shadow:
          0 14px 34px rgba(0, 0, 0, 0.50),
          0 0 18px rgba(127, 56, 198, 0.22),
          inset 0 1px 0
            rgba(255, 255, 255, 0.08);
      }

      .natal-floating-top-back:active {
        transform: scale(0.92);
      }

      .natal-floating-top-back:focus-visible {
        outline:
          2px solid var(--natal-gold);
        outline-offset: 3px;
      }

      @media (max-width: 520px) {
        .natal-floating-top-back {
          left: 14px;
        }
      }

      @media (max-width: 390px) {
        .natal-premium-header {
          grid-template-columns:
            38px minmax(0, 1fr) 38px !important;
        }

        .natal-header-spacer {
          width: 38px;
          height: 38px;
        }

        .natal-floating-top-back {
          top:
            calc(
              10px
              + env(safe-area-inset-top, 0px)
            );
          left: 12px;
          width: 38px;
          height: 38px;
          font-size: 25px;
        }
      }
    

      /* ===========================================================
         PREMIUM FLOATING BACK BUTTON
         =========================================================== */

      .natal-floating-top-back{
        position:fixed;
        top:calc(14px + env(safe-area-inset-top,0px));
        left:max(14px,calc(50vw - 246px));
        z-index:999;

        width:46px;
        height:46px;

        display:flex;
        align-items:center;
        justify-content:center;

        border:none;
        border-radius:999px;

        overflow:visible;
        isolation:isolate;

        cursor:pointer;

        background:
        linear-gradient(
        145deg,
        rgba(63,22,112,.97),
        rgba(17,8,42,.98));

        border:1px solid rgba(237,205,109,.38);

        box-shadow:
        0 14px 35px rgba(0,0,0,.45),
        inset 0 1px 0 rgba(255,255,255,.08),
        0 0 20px rgba(125,55,210,.18);

        backdrop-filter:blur(8px);
        -webkit-backdrop-filter:blur(8px);

        transition:
        .18s transform,
        .18s box-shadow,
        .18s border-color;
      }

      .natal-floating-top-back::before{
        content:"";
        position:absolute;
        inset:2px;
        border-radius:inherit;
        border:1px solid rgba(255,255,255,.05);
        pointer-events:none;
    }

      .natal-floating-top-back-glow{
        position:absolute;
        inset:-10px;
        border-radius:999px;

        background:
        radial-gradient(circle,
        rgba(144,73,224,.28),
        transparent 70%);

        opacity:.8;
        z-index:-1;

        transition:.18s;
    }

      .natal-floating-top-back-icon{

        position:relative;
        z-index:2;

        font-size:32px;
        font-weight:400;
        line-height:1;

        transform:
        translateX(-1px)
        translateY(-2px);

        color:#fff9e4;

        text-shadow:
        0 0 12px rgba(255,222,125,.35);

        transition:.18s;
      }

      .natal-floating-top-back:hover{

        transform:
        translateY(-2px);

        border-color:
        rgba(255,222,145,.8);

        box-shadow:
        0 18px 38px rgba(0,0,0,.5),
        inset 0 1px 0 rgba(255,255,255,.08),
        0 0 28px rgba(148,76,226,.28);

      }

      .natal-floating-top-back:hover
      .natal-floating-top-back-glow{

        transform:scale(1.08);
        opacity:1;

      }

      .natal-floating-top-back:hover
      .natal-floating-top-back-icon{

        transform:
        translateX(-3px)
        translateY(-2px);

      }

      .natal-floating-top-back:active{

        transform:
        scale(.92);

      }

      .natal-floating-top-back:focus-visible{

        outline:2px solid #DAA520;
        outline-offset:3px;

      }

      @media(max-width:520px){

        .natal-floating-top-back{

          left:14px;

        }

      }

      @media(max-width:390px){

        .natal-floating-top-back{

          width:42px;
          height:42px;

        }

        .natal-floating-top-back-icon{

          font-size:29px;

        }

      }




      /* ==========================================================
         PREMIUM ASPECT CARDS
         ========================================================== */

      .aspect-card{

        display:flex;
        flex-direction:column;
        gap:14px;

        padding:18px;

        border-radius:18px;

        border:1px solid rgba(255,255,255,.08);

        background:
        linear-gradient(
        180deg,
        rgba(46,18,83,.88),
        rgba(20,8,45,.94));

        box-shadow:
        inset 0 1px 0 rgba(255,255,255,.04),
        0 12px 26px rgba(0,0,0,.28);

      }

      .aspect-top{

        display:flex;
        justify-content:space-between;
        align-items:flex-start;
        gap:16px;

      }

      .aspect-titleWrap{

        flex:1;
        min-width:0;

      }

      .aspect-kicker{

        font-size:10px;

        text-transform:uppercase;

        letter-spacing:.7px;

        color:#C9A94C;

        font-weight:900;

        margin-bottom:4px;

      }

      .aspect-title{

        font-size:18px;

        line-height:1.25;

        font-weight:800;

        color:white;

      }

      .aspect-glyph{

        font-size:34px;

        color:#F7D26A;

        flex-shrink:0;

        line-height:1;

      }

      .aspect-chiprow{

        display:flex;

        flex-wrap:wrap;

        gap:8px;

        margin-top:-2px;

      }

      .aspect-chip{

        display:inline-flex;

        align-items:center;

        justify-content:center;

        padding:6px 12px;

        border-radius:999px;

        font-size:11px;

        font-weight:700;

        line-height:1;

        white-space:nowrap;

      }

      .aspect-copy{

        display:flex;

        flex-direction:column;

        gap:12px;

      }

      .aspect-intro{

        font-size:14px;

        line-height:1.65;

        color:rgba(255,255,255,.95);

      }

      .aspect-body{

        font-size:13px;

        line-height:1.75;

        color:rgba(255,255,255,.82);

      }






      



      /* Cards compactas para la síntesis premium */
      .integrated-metrics-grid {
        display: grid;
        grid-template-columns:
          repeat(2, minmax(0, 1fr));
        gap: 10px;
        margin-top: 14px;
      }

      .integrated-metric-card {
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 12px 13px;
        border-radius: 14px;
        border:
          1px solid rgba(143, 72, 205, 0.42);
        background:
          linear-gradient(
            145deg,
            rgba(50, 16, 88, 0.88),
            rgba(20, 7, 44, 0.94)
          );
        box-shadow:
          0 8px 20px rgba(0, 0, 0, 0.20),
          inset 0 1px 0
            rgba(255, 255, 255, 0.04);
      }

      .integrated-metric-label {
        color: var(--natal-muted);
        font-size: 9.5px;
        line-height: 1.2;
        text-transform: uppercase;
        letter-spacing: 0.62px;
        font-weight: 800;
      }

      .integrated-metric-value {
        color: var(--natal-gold-soft);
        font-size: 12.5px;
        line-height: 1.4;
        font-weight: 800;
        overflow-wrap: anywhere;
      }

      .integrated-metric-card:nth-child(5) {
        grid-column: 1 / -1;
      }

      .integrated-metric-card:nth-child(5)
      .integrated-metric-value {
        font-size: 14px;
      }

      @media (max-width: 390px) {
        .integrated-metrics-grid {
          grid-template-columns: 1fr;
        }

        .integrated-metric-card:nth-child(5) {
          grid-column: auto;
        }
      }



      /* Aspectos premium v2 */
      .aspect-card {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 13px;
        padding: 15px !important;
        border-radius: 16px !important;
        border:
          1px solid rgba(143, 72, 205, 0.42)
          !important;
        background:
          radial-gradient(
            circle at 92% 4%,
            rgba(126, 53, 190, 0.18),
            transparent 34%
          ),
          linear-gradient(
            145deg,
            rgba(45, 13, 80, 0.96),
            rgba(15, 5, 34, 0.98)
          ) !important;
        box-shadow:
          0 12px 28px rgba(0, 0, 0, 0.26),
          inset 0 1px 0
            rgba(255, 255, 255, 0.04)
          !important;
        overflow: hidden;
      }

      .aspect-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background:
          linear-gradient(
            90deg,
            var(--natal-gold),
            var(--natal-purple),
            transparent
          );
        opacity: 0.82;
      }

      .aspect-top {
        display: grid;
        grid-template-columns:
          minmax(0, 1fr) 44px;
        align-items: center;
        gap: 12px;
      }

      .aspect-titleWrap {
        min-width: 0;
      }

      .aspect-kicker {
        margin-bottom: 4px;
        color: var(--natal-muted) !important;
        font-size: 9.5px;
        font-weight: 800;
        line-height: 1.2;
        letter-spacing: 0.75px;
        text-transform: uppercase;
      }

      .aspect-title {
        color: var(--natal-gold-soft) !important;
        font-size: 14px;
        font-weight: 850;
        line-height: 1.35;
        overflow-wrap: anywhere;
      }

      .aspect-glyph {
        width: 42px;
        height: 42px;
        display: grid;
        place-items: center;
        justify-self: end;
        border-radius: 50%;
        border:
          1px solid rgba(234, 198, 93, 0.34);
        background:
          rgba(27, 8, 55, 0.82);
        color: var(--natal-gold-soft) !important;
        font-size: 25px;
        line-height: 1;
        box-shadow:
          inset 0 1px 0
            rgba(255, 255, 255, 0.05),
          0 7px 18px rgba(0, 0, 0, 0.22);
      }

      .aspect-chiprow {
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: center;
        gap: 7px !important;
        margin: 0 !important;
      }

      .aspect-chip {
        display: inline-flex !important;
        align-items: center;
        min-height: 27px;
        padding: 6px 10px !important;
        border-radius: 999px !important;
        border:
          1px solid rgba(255, 255, 255, 0.08);
        font-size: 10.5px !important;
        font-weight: 800 !important;
        line-height: 1 !important;
        white-space: nowrap;
      }

      .aspect-chip-secondary {
        color: #e2d5ef;
        border-color:
          rgba(144, 74, 204, 0.36);
        background:
          rgba(35, 11, 65, 0.82);
      }

      .aspect-content {
        padding-top: 12px;
        border-top:
          1px solid rgba(255, 255, 255, 0.07);
      }

      .aspect-copy {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .aspect-intro {
        color:
          rgba(255, 250, 240, 0.96)
          !important;
        font-size: 12.5px;
        font-weight: 650;
        line-height: 1.62;
      }

      .aspect-body {
        color:
          rgba(224, 212, 235, 0.88)
          !important;
        font-size: 12px;
        line-height: 1.68;
      }

      .aspect-fallback {
        padding-top: 11px;
        border-top:
          1px solid rgba(255, 255, 255, 0.07);
        color:
          rgba(224, 212, 235, 0.88);
        font-size: 12px;
        line-height: 1.65;
      }

      @media (max-width: 390px) {
        .aspect-card {
          padding: 13px !important;
        }

        .aspect-top {
          grid-template-columns:
            minmax(0, 1fr) 38px;
          gap: 9px;
        }

        .aspect-glyph {
          width: 36px;
          height: 36px;
          font-size: 22px;
        }

        .aspect-title {
          font-size: 13px;
        }

        .aspect-chip {
          padding:
            6px 9px !important;
          font-size:
            10px !important;
        }
      }



      /* Regente y grado en líneas separadas */
      .it-chiprow {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 7px;
      }

      .it-chip {
        width: 100%;
        box-sizing: border-box;
      }

      .it-chip-ruler,
      .it-chip-degree {
        display: block;
        width: 100%;
        padding: 8px 10px;
        border-radius: 10px;
        white-space: normal;
        line-height: 1.35;
      }

      .it-chip-degree {
        color: var(--natal-gold-soft);
        border:
          1px solid rgba(234, 198, 93, 0.28);
        background:
          rgba(55, 18, 90, 0.62);
      }



      /* NATAL PREMIUM INTERFACE V3 */

      :root {
        --natal-v3-bg: #070511;
        --natal-v3-panel: rgba(27, 8, 52, 0.94);
        --natal-v3-panel-deep: rgba(13, 4, 30, 0.97);
        --natal-v3-panel-light: rgba(53, 15, 91, 0.86);
        --natal-v3-gold: #efca67;
        --natal-v3-gold-soft: #ffe7a1;
        --natal-v3-purple: #863fd0;
        --natal-v3-purple-soft: #b978ec;
        --natal-v3-text: #fffaf1;
        --natal-v3-muted: #c9b7db;
        --natal-v3-border: rgba(142, 67, 207, 0.40);
        --natal-v3-border-gold: rgba(239, 202, 103, 0.34);
      }

      #natalRoot {
        background:
          radial-gradient(
            circle at 18% 8%,
            rgba(117, 43, 179, 0.20),
            transparent 27%
          ),
          radial-gradient(
            circle at 86% 27%,
            rgba(80, 25, 145, 0.18),
            transparent 31%
          ),
          radial-gradient(
            circle at 52% 82%,
            rgba(69, 18, 127, 0.20),
            transparent 37%
          ),
          radial-gradient(
            circle at 14% 28%,
            rgba(255,255,255,0.62) 0 0.6px,
            transparent 1px
          ),
          radial-gradient(
            circle at 78% 17%,
            rgba(255,255,255,0.50) 0 0.6px,
            transparent 1px
          ),
          radial-gradient(
            circle at 61% 68%,
            rgba(255,255,255,0.38) 0 0.6px,
            transparent 1px
          ),
          linear-gradient(
            180deg,
            #06040f 0%,
            #090515 42%,
            #11051f 100%
          ) !important;
        background-size:
          auto,
          auto,
          auto,
          64px 64px,
          82px 82px,
          104px 104px,
          auto;
      }

      #natalRoot::before {
        content: '';
        position: fixed;
        inset: 0;
        z-index: 0;
        pointer-events: none;
        background:
          linear-gradient(
            180deg,
            rgba(4, 3, 13, 0.02),
            rgba(4, 3, 13, 0.28)
          );
      }

      .natal-premium-header {
        display: grid !important;
        grid-template-columns:
          44px minmax(0, 1fr) 44px !important;
        align-items: center !important;
        gap: 10px !important;
        margin: 0 0 14px !important;
        padding: 2px 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
      }

      .natal-header-copy {
        grid-column: 2;
        text-align: center !important;
      }

      .natal-header-copy h1 {
        margin: 0 !important;
        color: var(--natal-v3-gold-soft) !important;
        font-family:
          Georgia,
          'Times New Roman',
          serif !important;
        font-size: clamp(21px, 5.8vw, 27px) !important;
        font-weight: 500 !important;
        letter-spacing: 0.15px;
        text-shadow:
          0 0 18px rgba(239, 202, 103, 0.13);
      }

      .natal-header-copy p {
        margin: 4px 0 0 !important;
        color: var(--natal-v3-muted) !important;
        font-size: 11px !important;
        letter-spacing: 0.1px;
      }

      .natal-header-spacer {
        width: 44px;
        height: 44px;
        display: block;
      }

      .natal-floating-top-back {
        position: fixed !important;
        top:
          calc(
            13px +
            env(safe-area-inset-top, 0px)
          ) !important;
        left:
          max(
            14px,
            calc(50vw - 244px)
          ) !important;
        z-index: 180 !important;
        width: 42px !important;
        height: 42px !important;
        display: grid !important;
        place-items: center !important;
        padding: 0 !important;
        border-radius: 50% !important;
        border:
          1px solid
          rgba(239, 202, 103, 0.36) !important;
        background:
          linear-gradient(
            145deg,
            rgba(61, 20, 104, 0.98),
            rgba(17, 6, 40, 0.99)
          ) !important;
        color: #fff8dd !important;
        box-shadow:
          0 12px 28px rgba(0,0,0,0.44),
          0 0 18px rgba(126, 55, 193, 0.17),
          inset 0 1px 0
            rgba(255,255,255,0.07) !important;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
      }

      .natal-floating-top-back-icon {
        transform: translate(-1px, -1px);
        font-family:
          Georgia,
          'Times New Roman',
          serif;
        font-size: 29px;
        line-height: 1;
      }

      .natal-success-pill {
        width: fit-content;
        max-width: calc(100% - 28px);
        margin: 0 auto 14px !important;
        padding: 7px 13px !important;
        border-radius: 999px !important;
        border:
          1px solid
          rgba(91, 221, 137, 0.24) !important;
        background:
          rgba(26, 75, 48, 0.31) !important;
        color: #ddffe7 !important;
        font-size: 11px !important;
        box-shadow:
          0 8px 20px rgba(0,0,0,0.18);
      }

      .natal-status-message {
        margin: 10px 0 0 !important;
        padding: 8px 12px !important;
        border-radius: 12px !important;
        text-align: center;
        font-size: 11.5px !important;
      }

      .natal-birth-toggle {
        min-height: 62px;
        margin: 12px 0 14px !important;
        padding: 13px 14px !important;
        border-radius: 17px !important;
        border:
          1px solid
          var(--natal-v3-border) !important;
        background:
          linear-gradient(
            135deg,
            rgba(49, 13, 85, 0.94),
            rgba(21, 6, 46, 0.97)
          ) !important;
        box-shadow:
          0 11px 25px rgba(0,0,0,0.24),
          inset 0 1px 0
            rgba(255,255,255,0.04) !important;
      }

      .natal-birth-toggle-icon {
        width: 34px;
        height: 34px;
        display: grid;
        place-items: center;
        border-radius: 11px;
        background:
          rgba(74, 24, 119, 0.52);
        font-size: 17px;
      }

      .natal-birth-toggle-copy strong {
        color: var(--natal-v3-gold-soft) !important;
        font-size: 12.5px !important;
      }

      .natal-birth-toggle-copy small {
        color: var(--natal-v3-muted) !important;
        font-size: 10.5px !important;
      }

      .natal-result-shell {
        display: flex !important;
        flex-direction: column !important;
        gap: 14px !important;
        margin-top: 14px !important;
      }

      .natal-summary-heading {
        padding: 2px 2px 0 !important;
      }

      .natal-summary-heading > div:first-child {
        color: var(--natal-v3-gold-soft) !important;
        font-size: 13px !important;
        font-weight: 850 !important;
        letter-spacing: 0.45px;
        text-transform: uppercase;
      }

      .natal-summary-heading > div:last-child {
        color: var(--natal-v3-muted) !important;
        font-size: 10.5px !important;
      }

      .natal-summary-card {
        position: relative;
        display: grid !important;
        gap: 7px !important;
        padding: 13px 14px 13px 16px !important;
        border-radius: 15px !important;
        border:
          1px solid
          var(--natal-v3-border) !important;
        background:
          linear-gradient(
            145deg,
            rgba(42, 12, 75, 0.96),
            rgba(15, 5, 34, 0.98)
          ) !important;
        box-shadow:
          0 12px 27px rgba(0,0,0,0.25),
          inset 0 1px 0
            rgba(255,255,255,0.04) !important;
        overflow: hidden;
      }

      .natal-summary-card::before {
        content: '';
        position: absolute;
        inset: 0 auto 0 0;
        width: 3px;
        background:
          linear-gradient(
            180deg,
            var(--natal-v3-gold),
            var(--natal-v3-purple)
          );
      }

      .natal-summary-card > div {
        min-height: 31px;
        display: flex !important;
        align-items: center;
        padding: 5px 7px !important;
        border-radius: 10px;
        background:
          rgba(15, 5, 34, 0.36);
        color: var(--natal-v3-text) !important;
        font-size: 11.5px !important;
      }

      .natal-wheel-card {
        min-height: 290px !important;
        padding: 14px !important;
        border-radius: 19px !important;
        border:
          1px solid
          var(--natal-v3-border-gold) !important;
        background:
          radial-gradient(
            circle at center,
            rgba(125, 51, 190, 0.24),
            transparent 60%
          ),
          linear-gradient(
            145deg,
            rgba(34, 9, 63, 0.98),
            rgba(10, 3, 26, 0.99)
          ) !important;
        box-shadow:
          0 16px 35px rgba(0,0,0,0.32),
          0 0 32px rgba(119, 45, 184, 0.10),
          inset 0 1px 0
            rgba(255,255,255,0.04) !important;
        overflow: hidden;
      }

      .natal-wheel-card > div {
        width: min(340px, 87vw) !important;
        height: min(340px, 87vw) !important;
        margin: 0 auto;
      }

      .natal-wheel-expand {
        min-height: 38px !important;
        margin-top: -5px;
        border-radius: 12px !important;
        border:
          1px solid
          rgba(138, 67, 202, 0.33) !important;
        background:
          rgba(30, 8, 58, 0.80) !important;
        color: #dfd1ee !important;
        font-size: 10.5px !important;
      }

      .natal-chart-tabs {
        position: sticky;
        top:
          calc(
            8px +
            env(safe-area-inset-top, 0px)
          );
        z-index: 70;
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 4px !important;
        padding: 3px !important;
        margin: 0 !important;
        border-radius: 14px !important;
        border:
          1px solid
          rgba(138, 66, 203, 0.34) !important;
        background:
          rgba(16, 5, 37, 0.91) !important;
        box-shadow:
          0 10px 25px rgba(0,0,0,0.24);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
      }

      .natal-chart-tab {
        min-height: 38px !important;
        border: 0 !important;
        border-radius: 11px !important;
        background: transparent !important;
        color: #d9cae7 !important;
        font-size: 11.5px !important;
        font-weight: 750 !important;
      }

      .natal-chart-tab.is-active {
        color: #fff !important;
        background:
          linear-gradient(
            135deg,
            rgba(103, 28, 173, 0.98),
            rgba(62, 12, 118, 0.98)
          ) !important;
        box-shadow:
          0 6px 15px rgba(0,0,0,0.19),
          inset 0 1px 0
            rgba(255,255,255,0.08) !important;
      }

      .natal-data-panel {
        padding: 10px !important;
        border-radius: 17px !important;
        border:
          1px solid
          var(--natal-v3-border) !important;
        background:
          linear-gradient(
            145deg,
            rgba(36, 10, 66, 0.96),
            rgba(13, 4, 31, 0.98)
          ) !important;
        box-shadow:
          0 13px 29px rgba(0,0,0,0.25),
          inset 0 1px 0
            rgba(255,255,255,0.04) !important;
      }

      .natal-planets-panel > div {
        border-color:
          rgba(255,255,255,0.065) !important;
      }

      .natal-planets-panel > div:not(:first-child) {
        min-height: 54px;
        padding:
          8px 7px !important;
        border-radius: 10px;
        transition:
          background 160ms ease,
          transform 160ms ease;
      }

      .natal-planets-panel > div:not(:first-child):hover {
        background:
          rgba(73, 24, 114, 0.24);
        transform: translateX(2px);
      }

      .natal-houses-panel {
        padding: 11px !important;
      }

      .natal-houses-panel > div:last-child {
        display: grid !important;
        grid-template-columns:
          repeat(4, minmax(0, 1fr)) !important;
        gap: 8px !important;
      }

      .natal-houses-panel > div:last-child > div {
        min-height: 78px;
        padding: 9px 5px !important;
        border-radius: 12px !important;
        border:
          1px solid
          rgba(139, 68, 204, 0.36) !important;
        background:
          linear-gradient(
            145deg,
            rgba(48, 14, 83, 0.78),
            rgba(21, 6, 46, 0.90)
          ) !important;
        box-shadow:
          inset 0 1px 0
            rgba(255,255,255,0.035);
      }

      .natal-accordion {
        position: relative;
        margin: 0 !important;
        overflow: hidden;
        border-radius: 15px !important;
        border:
          1px solid
          var(--natal-v3-border) !important;
        background:
          linear-gradient(
            135deg,
            rgba(42, 11, 75, 0.94),
            rgba(19, 5, 42, 0.97)
          ) !important;
        box-shadow:
          0 9px 23px rgba(0,0,0,0.21),
          inset 0 1px 0
            rgba(255,255,255,0.035) !important;
      }

      .natal-accordion::before {
        content: '';
        position: absolute;
        left: 0;
        top: 11px;
        bottom: 11px;
        width: 3px;
        border-radius: 0 4px 4px 0;
        background:
          linear-gradient(
            180deg,
            var(--natal-v3-gold),
            var(--natal-v3-purple)
          );
        opacity: 0.75;
      }

      .natal-accordion-trigger {
        min-height: 60px !important;
        padding: 11px 12px 11px 16px !important;
      }

      .natal-accordion-copy strong {
        color: var(--natal-v3-gold-soft) !important;
        font-size: 12px !important;
        line-height: 1.25;
      }

      .natal-accordion-copy small {
        color: var(--natal-v3-muted) !important;
        font-size: 10.3px !important;
        line-height: 1.35;
      }

      .natal-accordion-chevron {
        font-size: 19px !important;
        opacity: 0.84;
      }

      .natal-accordion.is-open {
        border-color:
          rgba(239, 202, 103, 0.30) !important;
        box-shadow:
          0 13px 31px rgba(0,0,0,0.27),
          inset 0 1px 0
            rgba(255,255,255,0.04) !important;
      }

      .natal-accordion-content {
        padding: 11px !important;
        border-top:
          1px solid
          rgba(255,255,255,0.06);
        background:
          rgba(8, 3, 22, 0.31) !important;
      }

      .dominant-card,
      .pattern-card,
      .aspect-card,
      .integrated-card,
      .it-card {
        border-radius: 15px !important;
        border:
          1px solid
          rgba(139, 68, 204, 0.36) !important;
        background:
          linear-gradient(
            145deg,
            rgba(42, 12, 76, 0.91),
            rgba(15, 5, 34, 0.96)
          ) !important;
        box-shadow:
          0 10px 24px rgba(0,0,0,0.22),
          inset 0 1px 0
            rgba(255,255,255,0.035) !important;
      }

      .dominant-metrics-grid,
      .integrated-metrics-grid {
        gap: 9px !important;
      }

      .dominant-metric-card,
      .integrated-metric-card {
        border-radius: 12px !important;
        border:
          1px solid
          rgba(140, 69, 204, 0.34) !important;
        background:
          linear-gradient(
            145deg,
            rgba(50, 15, 87, 0.76),
            rgba(20, 6, 44, 0.88)
          ) !important;
      }

      .it-title {
        color: var(--natal-v3-gold-soft) !important;
        font-size: 14px !important;
        line-height: 1.35;
      }

      .it-sub {
        color: var(--natal-v3-muted) !important;
        font-size: 10.5px !important;
        line-height: 1.45;
      }

      .it-chiprow {
        gap: 6px !important;
      }

      .it-chip {
        border-radius: 10px !important;
        border:
          1px solid
          rgba(139, 68, 204, 0.30) !important;
        background:
          rgba(40, 11, 72, 0.67) !important;
        color: #e7dcf1 !important;
        font-size: 10px !important;
      }

      .it-chip-degree {
        color: var(--natal-v3-gold-soft) !important;
        border-color:
          rgba(239, 202, 103, 0.28) !important;
      }

      .natal-primary-action {
        min-height: 48px !important;
        border-radius: 15px !important;
        border:
          1px solid
          var(--natal-v3-border-gold) !important;
        background:
          linear-gradient(
            135deg,
            rgba(68, 20, 112, 0.97),
            rgba(28, 8, 59, 0.99)
          ) !important;
        color: var(--natal-v3-gold-soft) !important;
        box-shadow:
          0 12px 27px rgba(0,0,0,0.27),
          inset 0 1px 0
            rgba(255,255,255,0.05) !important;
      }

      #natalRoot input,
      #natalRoot select,
      #natalRoot textarea {
        min-height: 43px;
        border-radius: 12px !important;
        border:
          1px solid
          rgba(139, 68, 204, 0.42) !important;
        background:
          rgba(12, 4, 30, 0.91) !important;
        color: #fff !important;
      }

      @media (max-width: 520px) {
        .natal-floating-top-back {
          left: 12px !important;
        }

        .natal-wheel-card {
          min-height: 260px !important;
        }

        .natal-houses-panel > div:last-child {
          grid-template-columns:
            repeat(4, minmax(0, 1fr)) !important;
        }
      }

      @media (max-width: 390px) {
        .natal-premium-header {
          grid-template-columns:
            39px minmax(0, 1fr) 39px !important;
        }

        .natal-header-spacer {
          width: 39px;
          height: 39px;
        }

        .natal-header-copy h1 {
          font-size: 20px !important;
        }

        .natal-floating-top-back {
          width: 39px !important;
          height: 39px !important;
          top:
            calc(
              10px +
              env(safe-area-inset-top, 0px)
            ) !important;
        }

        .natal-summary-card {
          padding:
            12px 12px 12px 15px !important;
        }

        .natal-wheel-card {
          min-height: 230px !important;
          padding: 10px !important;
        }

        .natal-houses-panel > div:last-child {
          grid-template-columns:
            repeat(3, minmax(0, 1fr)) !important;
        }

        .natal-accordion-trigger {
          min-height: 56px !important;
        }
      }

      /* Premium observatory layer: presentation-only refinements. */
      #natalRoot {
        background:
          radial-gradient(circle at 12% 8%, rgba(130, 70, 210, 0.22), transparent 30%),
          radial-gradient(circle at 88% 24%, rgba(64, 44, 148, 0.18), transparent 32%),
          radial-gradient(circle at 50% 100%, rgba(108, 39, 160, 0.24), transparent 42%),
          linear-gradient(180deg, #070617 0%, #0a071b 48%, #120722 100%) !important;
      }

      #natalRoot::after {
        content: '';
        position: fixed;
        width: min(92vw, 620px);
        height: min(92vw, 620px);
        top: 12%;
        left: 50%;
        transform: translateX(-50%);
        border: 1px solid rgba(241, 200, 90, 0.07);
        border-radius: 50%;
        box-shadow: 0 0 0 34px rgba(126, 74, 191, 0.025), 0 0 0 78px rgba(126, 74, 191, 0.018);
        pointer-events: none;
        z-index: 0;
      }

      .natal-content-column {
        width: 100%;
        max-width: 620px !important;
      }

      .natal-premium-header {
        margin-bottom: 18px !important;
      }

      .natal-header-eyebrow {
        display: block;
        margin-bottom: 6px;
        color: var(--natal-purple-soft);
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 0.22em;
        line-height: 1.2;
      }

      .natal-header-copy h1 {
        letter-spacing: 0.01em !important;
      }

      .natal-header-copy p {
        max-width: 32ch;
        margin-left: auto !important;
        margin-right: auto !important;
        line-height: 1.5;
      }

      .natal-birth-form {
        padding: 16px;
        border: 1px solid rgba(157, 91, 216, 0.26);
        border-radius: 20px;
        background: linear-gradient(145deg, rgba(31, 10, 56, 0.82), rgba(12, 5, 30, 0.88));
        box-shadow: 0 16px 34px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
      }

      .natal-birth-form > div {
        gap: 6px !important;
      }

      .natal-birth-form label {
        display: block;
        font-size: 11px !important;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
      }

      #natalRoot input,
      #natalRoot select,
      #natalRoot textarea {
        min-height: 46px !important;
        padding: 10px 12px !important;
        border-color: rgba(157, 91, 216, 0.34) !important;
        background: rgba(9, 4, 24, 0.82) !important;
        transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
      }

      #natalRoot input:focus,
      #natalRoot select:focus,
      #natalRoot textarea:focus {
        border-color: rgba(241, 200, 90, 0.76) !important;
        background: rgba(17, 7, 38, 0.96) !important;
        box-shadow: 0 0 0 3px rgba(241, 200, 90, 0.12), 0 8px 20px rgba(0, 0, 0, 0.2) !important;
        outline: none;
      }

      .natal-primary-action {
        min-height: 50px;
        background: linear-gradient(135deg, #7e4ac0 0%, #4c237e 52%, #342050 100%) !important;
        color: #fff4c7 !important;
        letter-spacing: 0.02em;
        box-shadow: 0 14px 28px rgba(36, 12, 73, 0.46), inset 0 1px 0 rgba(255, 255, 255, 0.12) !important;
      }

      .natal-result-shell {
        padding: 16px !important;
        border-color: rgba(241, 200, 90, 0.26) !important;
        background: linear-gradient(160deg, rgba(27, 10, 52, 0.96), rgba(10, 5, 25, 0.98)) !important;
      }

      .natal-summary-card {
        padding: 14px 14px 14px 18px !important;
        background: linear-gradient(145deg, rgba(55, 24, 86, 0.78), rgba(19, 8, 42, 0.88)) !important;
      }

      .natal-summary-card > div {
        padding: 4px 0;
        line-height: 1.55;
      }

      .natal-wheel-card {
        padding: 14px !important;
        border: 1px solid rgba(157, 91, 216, 0.22);
        border-radius: 20px;
        background: radial-gradient(circle at 50% 40%, rgba(126, 74, 191, 0.25), transparent 60%), rgba(8, 4, 22, 0.54);
      }

      .natal-accordion {
        border-radius: 18px !important;
      }

      .natal-accordion-content {
        padding: 0 14px 14px !important;
      }

      .aspect-card,
      .dominant-card,
      .pattern-card,
      .integrated-card,
      .it-card {
        border-color: rgba(157, 91, 216, 0.28) !important;
        background: linear-gradient(145deg, rgba(42, 16, 70, 0.92), rgba(14, 6, 32, 0.96)) !important;
      }

      .aspect-body,
      .aspect-intro,
      .integrated-paragraph,
      .dominant-paragraph,
      .it-text {
        max-width: 68ch;
        line-height: 1.72 !important;
      }

      @media (min-width: 768px) {
        #natalRoot {
          padding-left: 24px !important;
          padding-right: 24px !important;
        }

        .natal-content-column {
          max-width: 700px !important;
        }

        .natal-result-shell {
          padding: 22px !important;
        }
      }

      /* Editorial interpretation density */
      .aspect-card { gap: 10px !important; padding: 13px !important; }
      .aspect-editorial-block { display: flex; flex-direction: column; gap: 5px; }
      .aspect-section-label {
        color: var(--natal-gold-soft);
        font-size: 9px;
        font-weight: 900;
        letter-spacing: .75px;
        text-transform: uppercase;
      }
      .aspect-key-idea { padding-bottom: 3px; }
      .aspect-bullet-list {
        display: grid;
        gap: 4px;
        margin: 0;
        padding-left: 17px;
        color: rgba(235, 224, 242, .88);
        font-size: 11.5px;
        line-height: 1.45;
      }
      .aspect-bullet-list li::marker { color: var(--natal-gold-soft); }
      .aspect-editorial-detail {
        border-top: 1px solid rgba(255,255,255,.08);
        padding-top: 8px;
        color: rgba(224, 212, 235, .76);
        font-size: 11.5px;
        line-height: 1.55;
      }
      .aspect-detail-toggle,
      .aspect-list-toggle {
        align-self: flex-start;
        border: 0;
        min-height: 44px;
        padding: 10px 0;
        background: transparent;
        color: var(--natal-gold-soft);
        cursor: pointer;
        font-size: 10.5px;
        font-weight: 800;
      }
      .aspect-detail-toggle:focus-visible,
      .aspect-list-toggle:focus-visible {
        outline: 2px solid var(--natal-gold-soft);
        outline-offset: 3px;
        border-radius: 4px;
      }
      .aspect-intensity-inline {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        min-height: 27px;
        padding: 4px 8px;
        border: 1px solid rgba(234,198,93,.22);
        border-radius: 999px;
        color: var(--natal-gold-soft);
        font-size: 10px;
        font-weight: 900;
      }
      .aspect-intensity-track {
        display: block;
        width: 42px;
        height: 3px;
        overflow: hidden;
        border-radius: 99px;
        background: rgba(255,255,255,.12);
      }
      .aspect-intensity-track > span {
        display: block;
        height: 100%;
        border-radius: inherit;
        background: linear-gradient(90deg, var(--natal-purple), var(--natal-gold));
      }

      .it-compact-body { display: grid; gap: 10px; }
      .it-primary-insight { font-size: 13px; line-height: 1.55; color: rgba(246, 238, 251, .94); }
      .it-compact-row { display: flex; flex-direction: column; gap: 5px; }
      .it-compact-label { color: var(--natal-gold-soft); font-size: 9px; font-weight: 900; letter-spacing: .7px; text-transform: uppercase; }
      .it-compact-chips { display: flex; flex-wrap: wrap; gap: 6px; }
      .it-compact-chip { padding: 5px 8px; border: 1px solid rgba(234,198,93,.24); border-radius: 999px; color: rgba(246, 238, 251, .9); font-size: 10.5px; line-height: 1.2; }
      .it-compact-challenge { color: rgba(235, 224, 242, .88); font-size: 12px; line-height: 1.5; }
      .it-detail-toggle { align-self: flex-start; min-height: 44px; padding: 10px 0; border: 0; background: transparent; color: var(--natal-gold-soft); cursor: pointer; font-size: 10.5px; font-weight: 800; }
      .it-detail-toggle:focus-visible { outline: 2px solid var(--natal-gold-soft); outline-offset: 3px; border-radius: 4px; }
      .it-expanded-body { display: grid; gap: 12px; margin-top: 2px; padding: 12px 0 2px; border-top: 1px solid rgba(255,255,255,.09); }
      .it-expanded-section { display: grid; gap: 4px; padding-left: 10px; border-left: 2px solid rgba(234,198,93,.28); }
      .it-expanded-label { color: var(--natal-gold-soft); font-size: 9px; font-weight: 900; letter-spacing: .72px; text-transform: uppercase; }
      .it-expanded-text { color: rgba(235,224,242,.86); font-size: 12px; line-height: 1.55; }
      .it-expanded-technical { opacity: .78; }

      .natal-technical-details {
        margin: -2px 0 8px;
        color: rgba(224, 212, 235, .66);
        font-size: 10px;
        text-align: right;
      }
      .natal-technical-details summary {
        cursor: pointer;
        color: var(--natal-muted);
      }
      .natal-technical-details span { display: block; margin-top: 4px; }

`}
      

</style>
  );
}
